<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-10-31 17:55:03
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-10-08 16:31:44
 * @FilePath: \vue-hepha-order\src\views\base\OrderSource.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="priceContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>
        
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.config.createShipDateRange'" @click="handle('create')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('config.create') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" v-permission="'setting.config.editShipDateRange'" style="width:80px;" :disabled="props.record.editDisabled" @click="handle('edit', props.record)">
                    <icon-edit size="13" style="marginRight:5px;"/>
                    {{ $t('base.edit') }}
                </a-button>
                <a-button type="primary" status="danger" size="mini" v-permission="'setting.config.deleteShipDateRange'" :disabled="props.record.deleteDisabled" @click="handle('delete', props.record)">
                    <icon-delete size="13" style="marginRight:5px;"/>
                    {{ $t('base.delete') }}
                </a-button>
            </template>
        </Table>

        <!-- 新增经销商发货日期区间 -->
        <a-modal
            :title="t('config.create')"
            v-model:visible="visible" 
            width="40%"
            draggable
            :render-to-body="false"
            :onBeforeOk="onBeforeOk"
        >
            <Form
                :form="addShipDateRangeForm"
                @handleDateChange="handleDateChange"
            ></Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { BaseApi } from '@/api/BaseApi.js'; 
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { QueryShipDateRangeForm, AddShipDateRangeForm } from './queryConfig/AddForm'
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()

    const queryForm = reactive(QueryShipDateRangeForm)
    const addShipDateRangeForm = reactive(AddShipDateRangeForm)
    const visible = ref(false)
    const showForm = ref(false)
    const operateType = ref('add')
    const rowData = ref(null)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'80',
                align:'center',
            },
            {
                // title: '经销商',
                title:t('order.orderSource'),
                dataIndex: 'customer_name',
                key:'customer_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:'180'
            },
            {
                // title: '渠道来源编码',
                title:t('customer.customerErpCode'),
                dataIndex: 'customer_number',
                key:'customer_number',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:'170'
            },
            {
                // title: '日期区间',
                title:t('config.dateRange'),
                dataIndex: 'date_range',
                key:'date_range',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:'230'
            },
            {
                // title: '原因',
                title:t('config.reason'),
                dataIndex: 'reason',
                key:'reason',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '创建日期',
                title:t('log.createDate'),
                dataIndex: 'create_date',
                key:'create_date',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:'150'
            },
            // {
            //     // title: '更新日期',
            //     title:t('log.updateDate'),
            //     dataIndex: 'update_date',
            //     key:'update_date',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     width:'150'
            // },
            {
                // title: '创建人',
                title:t('order.createUser'),
                dataIndex: 'create_user_name',
                key:'create_user_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:'130'
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '160',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:20,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'reset':
                for(let key in queryForm.formData){
                    queryForm.formData[key] = ''
                }
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'create':
                visible.value = true
                operateType.value = 'add'
                addShipDateRangeForm.formField.forEach(i=>{
                    addShipDateRangeForm.formData[i.key] = ''
                    if(i.key == 'begin_date'){
                        i.disabled = false
                    }
                })
                break;
            case 'edit':
                visible.value = true
                operateType.value = 'edit'
                rowData.value = row
                addShipDateRangeForm.formField.forEach(i=>{
                    if(i.key != 'begin_date' && i.key != 'end_date'){
                        addShipDateRangeForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key] 
                    }else{
                        let date = timestampToDate(rowData.value.begin_timestamp * 1000).split(' ')[0]
                        addShipDateRangeForm.formData[i.key] = [timestampToDate(rowData.value.begin_timestamp * 1000).split(' ')[0], timestampToDate(rowData.value.end_timestamp * 1000).split(' ')[0]]
                        addShipDateRangeForm.formData.begin_timestamp = rowData.value.begin_timestamp
                        addShipDateRangeForm.formData.end_timestamp = rowData.value.end_timestamp
                        addShipDateRangeForm.formData.begin_date = timestampToDate(rowData.value.begin_timestamp * 1000)
                        addShipDateRangeForm.formData.end_date = timestampToDate(rowData.value.end_timestamp * 1000)
                        addShipDateRangeForm.formData.year = date.split('-')[0]
                        addShipDateRangeForm.formData.month = date.split('-')[1] < 10 && date.split('-')[1].indexOf('0') > -1? date.split('-')[1].split('0')[1] : date.split('-')[1]
                    }
                })

                let beginDate_item = addShipDateRangeForm.formField.find(i=> i.key == 'begin_date')
                beginDate_item.disabled = addShipDateRangeForm.formData.begin_timestamp <= Number(dateToTimestamp(`${getNowDate()} 00:00:00`))
                break;
            case 'delete':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        deleteShipDateRange(row)
                    }
                });
                break;
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        customer_name.value = val
        getList()
    }

    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handleSelectChange = (val)=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getList()
    }

    const handleDateChange = (val,opt)=>{
        // console.log(opt.key,'keyy',val)
        if(opt.key == 'begin_date'){
            addShipDateRangeForm.formData.year = !val? '' : val.split('-')[0]
            addShipDateRangeForm.formData.month = !val? '' : val.split('-')[1] < 10 && val.split('-')[1].indexOf('0') > -1? val.split('-')[1].split('0')[1] :val.split('-')[1]
            addShipDateRangeForm.formData.begin_timestamp = !val? '' : dateToTimestamp(`${val} 00:00:00`)
        }else if(opt.key == 'end_date'){
            addShipDateRangeForm.formData.end_timestamp = !val? '' : dateToTimestamp(`${val} 23:59:59`)
        }
    }

    // 获取发货日期区间列表
    const getList = async ()=>{
        let param = {
            ...queryForm.formData,
        }
        
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await BaseApi.getInstance().shipDateRangeList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    ...i,
                    No:index + 1,
                    date_range: `[ ${timestampToDate(i.begin_timestamp * 1000).split(' ')[0]}, ${timestampToDate(i.end_timestamp * 1000).split(' ')[0]} ]`,
                    create_date: timestampToDate(i.create_timestamp * 1000).split(' ')[0],
                    update_date: !i.update_timestamp? '-' : timestampToDate(i.update_timestamp * 1000).split(' ')[0],
                    reason: !i.reason? '-' : i.reason,
                    deleteDisabled: !(dateToTimestamp(getNowDate()) < i.begin_timestamp),
                    editDisabled: dateToTimestamp(getNowDate()) >= i.end_timestamp,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 新增发货日期区间
    const onBeforeOk = async ()=>{
        if(addShipDateRangeForm.formData.customer_id == ''){
            Message.error(t('order.orderSource') + ' ' + t('base.noEmpty'))
            return false
        }else if(addShipDateRangeForm.formData.begin_date == '' || !addShipDateRangeForm.formData.begin_date){
            Message.error(t('base.beginDate') + ' ' + t('base.noEmpty'))
            return false
        }else if(addShipDateRangeForm.formData.end_date == '' || !addShipDateRangeForm.formData.end_date){
            Message.error(t('base.endDate') + ' ' + t('base.noEmpty'))
            return false
        }
        let param = {
            customer_id:addShipDateRangeForm.formData.customer_id,
            year:addShipDateRangeForm.formData.year,
            month:addShipDateRangeForm.formData.month,
            begin_timestamp:addShipDateRangeForm.formData.begin_timestamp,
            end_timestamp:addShipDateRangeForm.formData.end_timestamp,
            reason: addShipDateRangeForm.formData.reason,
        }
        if(operateType.value == 'edit') param.id = rowData.value.id
        // console.log(param,'param')
        let res = await BaseApi.getInstance().saveShipDateRange(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            getList()
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 删除发货日期区间
    const deleteShipDateRange = async (row)=>{
        let res = await BaseApi.getInstance().deleteShipDateRange(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getList()
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 获取经销商列表
    const getDealerList = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let query_item = queryForm.formField.find(i=> i.key == 'customer_id')
            let item = addShipDateRangeForm.formField.find(i=> i.key == 'customer_id')
            item.options = []
            query_item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.type == 1){
                    item.options.push({
                        label:i.customer_name + ' | ' + i.customer_number,
                        value:i.id, // 来源类型 
                        code: i.customer_number, // erp客户编码
                    })
                    query_item.options.push({
                        label:i.customer_name,
                        value:i.id, // 来源类型 
                        code: i.customer_number, // erp客户编码
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight   - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async()=>{
        getList()
        getDealerList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-modal-body{
    text-align: center !important;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ .arco-form-item-label-col{
    width:0 !important;
}

/deep/ button:focus, button:focus-visible{
    outline:none;
}
</style>